var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepublicOfTheCongo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_1297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10 0H50V40H-10V0Z",
    fill: "#FBDE4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 40V0H30L-10 40Z",
    fill: "#009543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0V40H10L50 0Z",
    fill: "#DA1A35"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_1297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white",
    transform: "translate(-10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepublicOfTheCongo);
export default __webpack_public_path__ + "static/media/republic_of_the_congo.eb281061b9e2e976f0cbf3261c0a7030.svg";
export { ForwardRef as ReactComponent };